import { LayerType } from "../../types";
import { USUtilityStatusSummary } from "./USUtilityStatusSummary";

export const USUtilityStatusLayerType: LayerType = {
  id: "us-utility-status",
  LayerSummary: USUtilityStatusSummary,
};
